import * as styles from "./DogCarouselCard.module.scss";

import React from "react";

import image from "../../../static/img/dogComingSoon.svg";
import { pushToDataLayer } from "../../../utils/google";
import { mapEsDogDocToDogCarouselCardProps } from "../../../utils/mappers";
import FavouriteIcon from "../../FavouriteIcon/FavouriteIcon";
import LinkNoStyle from "../../common/LinkNoStyle/LinkNoStyle";
import ProcessedImage from "../../common/ProcessedImage/ProcessedImage";

export interface DogCarouselCardProps {
	dog: DogsTrust.DogData;
}

const sendToDataLayer = (data: Google.DataLayerObject) => {
	const currentPageUrl =
		typeof window !== "undefined" ? window.location.pathname : "";
	data.card_location = currentPageUrl;
	pushToDataLayer(data);
};

export const DogCarouselCard: React.FC<DogCarouselCardProps> = ({ dog }) => {
	const { imgSrc, imgAlt, title, body, label, url } =
		mapEsDogDocToDogCarouselCardProps(dog);
	return (
		<article className={styles.dogcardwrapper}>
			<LinkNoStyle
				onClick={() =>
					sendToDataLayer({
						event: "card_click",
						card_title: title, // title of clicked card
						card_sub_title: body, //sub title of clicked card
					})
				}
				to={url}
			>
				<div className={styles.dogcard}>
					<div className={styles.image}>
						<div className={styles.customborderprovider}>
							<ProcessedImage
								className={styles.cardimg}
								src={imgSrc?.length ? imgSrc : image}
								dimensions="400x300"
								width={220}
								height={165}
								alt={imgAlt || title}
								isDogImage
								noProcess={!imgSrc?.length}
								loading={"lazy"}
							/>
						</div>
					</div>
					<div className={styles.details}>
						<h2 data-variation="hideFromJumpLinks" className={styles.title}>
							{title}
						</h2>
						<p className={styles.text}>{body}</p>
						<p className={styles.text}>{label}</p>
					</div>
				</div>
			</LinkNoStyle>
			<FavouriteIcon
				dog={dog}
				dogData={{
					event: "card_favourite",
					card_title: title, // title of card added to wishlist
					card_sub_title: body, //sub title of card added to wishlist
				}}
			/>
		</article>
	);
};

export default DogCarouselCard;
